import { useMemo } from 'react'

import { Menu, MenuProps } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'

import { useSiderMenuStore } from './hooks/useStore'
import { MenuConfig } from './interface'

type AntdMenuItems = Exclude<MenuProps['items'], undefined>

const transform = (data: MenuConfig[]): AntdMenuItems => {
  return data.map(({ key, title, label, icon, children }) => {
    const item: AntdMenuItems[number] = {
      key,
      title,
      label,
      icon
    }
    if (children) {
      const newChildren = transform(children)
      if (newChildren.length) {
        ;(item as any).children = newChildren
      }
    }
    return item
  })
}

export const SiderMenu = (props: BasicProps) => {
  const { menus, openKeys, selectedKeys, setOpenKeys, setSelectedKeys } =
    useSiderMenuStore()

  const antdMenus = useMemo(() => {
    return transform(menus)
  }, [menus])

  return (
    <Menu
      {...props}
      key='siderMenu'
      items={antdMenus}
      mode='inline'
      openKeys={openKeys}
      selectedKeys={selectedKeys}
      onOpenChange={setOpenKeys}
      onSelect={setSelectedKeys}
    />
  )
}
